import { render, staticRenderFns } from "./CustomerSampleOrdersList.vue?vue&type=template&id=383edbce&scoped=true&"
import script from "./CustomerSampleOrdersList.vue?vue&type=script&lang=js&"
export * from "./CustomerSampleOrdersList.vue?vue&type=script&lang=js&"
import style0 from "./CustomerSampleOrdersList.vue?vue&type=style&index=0&id=383edbce&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "383edbce",
  null
  
)

export default component.exports